<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-bookmark'}"
	[headerText]="(!!bookmarkIcon.id ? T.EDIT_BOOKMARK_DIALOG_TITLE : T.ADD_BOOKMARK_DIALOG_TITLE) | translate"
	[showActionDivider]="false"
	[showClosingX]="true"
>
	<!--CONTENT-->
	<ng-container dialogContent>
		<form (ngSubmit)="doSave()" [formGroup]="inputGroup" class="addMarkerForm full-width-form">
			<!--MARKER SET NAME-->
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.ADD_BOOKMARK_DIALOG_ABBREVIATION_INPUT | translate: {maxChars: ABBREVIATION_MAX_CHARS} }}</mat-label>
				<input
					[maxlength]="ABBREVIATION_MAX_CHARS"
					[ngStyle]="{'text-transform': 'uppercase'}"
					formControlName="abbreviation"
					matInput
				/>
				@if (inputGroup.get("abbreviation").hasError("required")) {
					<mat-error>
						{{ T.ADD_BOOKMARK_DIALOG_ABBR_IS_REQUIRED | translate }}
					</mat-error>
				}
			</mat-form-field>

			<!--MARKER SET DESC-->
			<mat-form-field class="full-width-form" color="accent">
				<mat-label>{{ T.ADD_BOOKMARK_DIALOG_TOOLTIP_INPUT | translate }}</mat-label>
				<input formControlName="tooltip" matInput />
			</mat-form-field>

			<!--Marker Preview-->
			<div class="markerPreviewContainer">
				<h2 class="mat-h2 w-100">{{ T.CREATE_BOOKMARK_DIALOG_PREVIEW_LABEL | translate }}</h2>
				<div class="markerPreview">
					<div class="text">
						{{ getValueFromAbbreviation() }}
					</div>
				</div>
			</div>

			<button #submitButton hidden></button>
		</form>
	</ng-container>

	<!--ACTIONS-->
	<ng-container actions>
		@if (!!bookmarkIcon.id) {
			<sim-button (onClick)="doDelete()" [icon]="{fontSet: 'fa', fontIcon: 'fa-trash'}" color="warn" [label]="T.BUTTON_DELETE" />
		}
		<sim-button
			(onClick)="submitButton.click()"
			[icon]="{fontSet: 'fa', fontIcon: 'fa-check'}"
			color="accent"
			[label]="T.BUTTON_SAVE"
		/>
	</ng-container>
</sim-basic-material-dialog>
